document.addEventListener('alpine:init', () => {
  Alpine.data('GameBoy', () => ({
    flags: {
      initialized: false
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      let am = this;
      let canvas = am.$el.querySelector('#canvas-gb');
      window.gameboyObj = new gb(am.$el.dataset.file, canvas);
    },
    InitWatchers() {
      let am = this;
      let events = ['keyup', 'click', 'touchend']
      events.forEach(event_name => {
        document.addEventListener(event_name, () => {
          am.flags.initialized = true;
        });
      });
    }
  }));
});
